import type Experiments from '@alltrails/types/Experiments';

/**
 * The values of the trailheads release flag. Every value turns trailheads on in Explore, and each one picks how the pins look:
 * - trailhead-circle: trailhead pins with a count banner for trailheads with more than one trail
 * - guidepost-circle: the same pins drawn with the guidepost art
 * - trailhead-pill: trailhead pins in a pill that reads like the trail pins (trail length, or "x trails")
 * - guidepost-pill: the same pill drawn with the guidepost art
 */
export type TrailheadsExploreVariant = NonNullable<Experiments['web-disco-rm-trailheads-explore-variants']>['value'];

export type TrailheadPinStyle = {
  /** Names the sprite images the pins draw with: `trailhead-circle-default`, `guidepost-circle-default`, and so on. */
  iconPrefix: 'trailhead' | 'guidepost';
};

const pinStyles: Record<TrailheadsExploreVariant, TrailheadPinStyle> = {
  'trailhead-circle': { iconPrefix: 'trailhead' },
  'guidepost-circle': { iconPrefix: 'guidepost' }
};

export const defaultTrailheadsExploreVariant: TrailheadsExploreVariant = 'trailhead-circle';

export const isTrailheadsExploreVariant = (value: unknown): value is TrailheadsExploreVariant =>
  typeof value === 'string' && Object.hasOwn(pinStyles, value);

export const getTrailheadPinStyle = (variant: TrailheadsExploreVariant = defaultTrailheadsExploreVariant): TrailheadPinStyle => pinStyles[variant];
